
const ContactExplain = () => {
  return (
    <div className="component-contact">
      <div className="container-contact">
        <div className="title">Infos Pratiques</div>
        <div className="br"/>
        <div className="container-text">
          <div className="title">Cuisine</div>
          <div className="subtitle">Française Traditionnelle</div>
        </div>
        <div className="container-text">
          <div className="title">Type de restaurant</div>
          <div className="subtitle">Restaurant Traditionnel, Bistrot - Brasserie</div>
        </div>
        <div className="container-text">
          <div className="title">Services</div>
          <div className="subtitle">Salle Privative, Terrasse, Organisation d&rsquo;événements</div>
        </div>
        <div className="container-text">
          <div className="title">Moyens de paiement</div>
          <div className="subtitle">Visa, Cartes restaurant, Paiement Sans Contact, Eurocard/Mastercard, Espèces, Carte Bleue, American Express</div>
        </div>
      </div>
      <div className="container-contact">
        <div className="title">Horaires</div>
        <div className="br"/>
        <div className="container-text-horaire">
          <div className="text">Mardi - Samedi</div>
          <div className="text">12h00 - 14h30 / 19h00 - 1h00</div>
        </div>
        <div className="br-hour"/>
        <div className="container-text-horaire">
          <div className="text">Dimanche - Lundi</div>
          <div className="text">Fermé</div>
        </div>
        <div className="br-hour"/>
        <div className="container-contact-explain">
          <div className="title">Contact</div>
          <div className="br"/>
          <div className="subtitle">18 Av. Paul Doumer, 77590 Bois-le-Roi</div>
          <div className="subtitle">01 60 68 62 82</div>
          <div className="container-social-network">
            <a href="https://www.facebook.com/profile.php?id=100083342977316" style={{textDecoration:"none",cursor:"pointer"}}>
              <img src="/assets/logo/fb.png" alt="" className="logo-social-network" />
            </a>
            <a href="https://www.instagram.com/leblr77/" style={{textDecoration:"none",cursor:"pointer"}}>
              <img src="/assets/logo/insta.png" alt="" className="logo-social-network" />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactExplain